import React from "react";

/**
 * When true, in-page Footer / DeliveryBottomNav render a spacer only.
 * The real chrome lives outside AnimatedSwitch so it does not slide.
 */
export const PersistentFooterContext = React.createContext(false);
